import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/** Key glyph for the Settings → API keys menu entry. */
const IconApiKey: React.FC<IconProps> = ({
  size = 26,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M14 7a4 4 0 11-3.8 5.2L4 18.4V21h2.6l1-1v-1.6h1.6l1-1v-1.6h1.6l.6-.6A4 4 0 0014 7zm2 1.4a1 1 0 110 2 1 1 0 010-2z"
      fill="currentColor"
    />
  </svg>
);

export default IconApiKey;
